import React from 'react';
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import api from '../../services/api';

import './LoginPage.css';
import InformacionComponent from '../../components/LogIn/Informacion/Informacion';
import FormularioComponent from '../../components/LogIn/Formulario/Formulario';

const LoginPage = () => {

  const history = useHistory();

  async function login(usuario, password) {

    try { 

      const response = await api.postLogin(usuario, password);
      const data = response.data;
      
      const token = data.token;
      localStorage.setItem('appToken', token);
      localStorage.setItem('id_personal', data.id_personal);
      localStorage.setItem('personal_orientacion', data.personal_orientacion);
      localStorage.setItem('personal_prefectura', data.personal_prefectura);
      localStorage.setItem('personal_tutoria', data.personal_tutoria);

      if (data.personal_orientacion || data.personal_prefectura || data.personal_tutoria) {
        history.push('/maestros-react/panel');
      }
      else{
        swal("Acceso no permitido.", "Usuario no cuenta con permiso.", "info");
      }
    }catch (e){

      if(!e.response && !e.response.data) {
        swal("Error", "Intente de nuevo más tarde.", "error");
        return;
      }
      
      switch(e.response.data.status) {
        case 400:
          swal("Datos incorrectos.", "Usuario o contraseña incorrecta.", "info");
          break;
        default:
            console.log("ERROR" , e.response);
      }
    }
  }

  return (
    <div className="contenedor-centro-prefectos">
      <InformacionComponent />
      <FormularioComponent login= {login} />
    </div>
  );
};

export default LoginPage;
